export default [
    {
        text: 'ID',
        value: 'id',
    },
    {
        text: 'nombre familia',
        value: 'family',
    },
]
